import * as Sentry from '@sentry/react'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import i18next from 'i18next'
import { ZodError } from 'zod'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        !(error instanceof ZodError) && failureCount < 3
    }
  },
  queryCache: new QueryCache({
    onError(error, query) {
      Sentry.captureException(error)
      error.zodMessage = i18next.t('validationError')
      if (error instanceof ZodError) console.error(error, query)
    }
  }),
  mutationCache: new MutationCache({
    onError(error) {
      Sentry.captureException(error)
    }
  })
})
